@if(attributeValues) {
<div class="grid pl-4 mt-1 overview-details mr-0 surface-ground">
    @if (orderStatus === 'ORDER_REJECTED') {
    <div class="col-12 pl-0">
        <div class="col-12 pl-0">
            <div class="p-fluid rejection-box">
                <div class="rejection-header flex align-items-center font-semibold">
                    <img src="../../../../../../assets/images/mi-theme/light/nav/rejected-order-icon.png"
                        [attr.alt]="'order.lbl_red_tick' | translate">
                    <span class="pr-1" translate>order.lbl_order_reject</span> {{ attributeValues?.rejected_on |
                    date:'dd-MMM-yyyy' }}
                </div>
                <div class="rejection-subtitle text-base font-normal">
                    <span class="rejection"></span>
                    <span translate>order.lbl_was_rejected_reason</span>
                </div>
                <div class="rejection-reason">
                    <span class="rejection"></span>
                    <span translate>{{ attributeValues?.admin_rejection_reason }}</span>
                </div>
            </div>
        </div>
    </div>
    }

    <div class="col-6 md:col-12 lg:col-8 pl-0">
        <app-order-info [showDispatchDateCalendar]="showDispatchDateCalendar"
            [pendingDateOfDispatchModel]="pendingDateOfDispatchModel" (confirmDateChange)="confirmDateChange($event)"
            [orderStatus]="orderStatus"
            [displayOrderStatus]="getDisplayOrderStatus(attributeValues['order_status'])"
            [attributeValues]="attributeValues" [details]="details"
            [attributeLabels]="attributeLabels" [orderStatusColor]="orderStatusColor"
            [protocolAttrValue]="protocolAttrValue"
            [orderId]="orderId" [entityCode]="'order'" />

        @if (orderStatus !== 'NEW_ORDER') {

        @if (orderStatus === 'ORDER_PARTIALLY_RECEIVED') {
        <div class="card p-fluid">
            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-center mb-3">
                    <label class="card-heading uppercase" translate>order.lbl_return_order_confirmation</label>
                </div>
            </div>
            @for (product of returnProducts; track $index) {
            <div class="border-box p-0 mb-3">
                <div class="flex disabled-bg">
                    <div class="form-field field col">
                        <label class="detail-heading" translate>lbl_name
                        </label>
                        <div class="form-control font-bold">
                            {{product.name}}
                        </div>
                    </div>
                    <div class="form-field field col-1">
                        <label class="detail-heading" translate>order.lbl_qty
                        </label>
                        <div class="form-control font-bold">
                            {{product.qty}}
                        </div>
                    </div>
                </div>
                <div class="card p-fluid">
                    @for (item of product.item; track $index) {
                    <div class="flex p-2">
                        <div class="form-field col-3">
                            <label class="detail-heading" translate>order.lbl_qty_to_return</label>
                            <div class="form-control text-base font-semibold qty-table">{{ getOriginalQuantity(item)
                                }}</div>
                        </div>
                        <div class="form-field col-3">
                            <label class="detail-heading" translate>order.lbl_batch</label>
                            <div class="form-control text-base font-semibold qty-table">{{ getBatchNumber(item) }}
                            </div>
                        </div>
                        <div class="form-field col-3">
                            <label class="detail-heading" translate>lbl_expiry_date</label>
                            <div class="form-control text-base font-semibold qty-table">{{ getFormattedDate(item) }}
                            </div>
                        </div>
                        <div class="form-field col-3">
                            <label class="detail-heading" translate>order.lbl_rejection_reason_type</label>
                            <div class="form-control text-base font-semibold qty-table">{{
                                (item.values.rejection_reason_type | keyvalue)[0]?.value
                                }}
                            </div>
                        </div>
                    </div>
                    @if (item.values.reject_reason) {
                    <div class="form-field col-12">
                        <label class="detail-heading" translate>order.lbl_rejection_reason</label>
                        <div class="form-control text-base font-semibold qty-table">{{ item.values.reject_reason
                            }}
                        </div>
                    </div>
                    }
                    }
                </div>

            </div>
            }
            <app-quantity-product-table [orderSummary]="returnOrderSummary"
                [products]="products" [isReturn]="true"></app-quantity-product-table>
        </div>



        }

        <div class="card p-fluid">
            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-center mb-3">
                    <label class="card-heading uppercase" translate>order.lbl_order_confirmation</label>
                </div>
            </div>
            <!-- <pre>{{deliveryProducts|json}}</pre> -->
            @for (product of deliveryProducts; track $index) {
            <div class="border-box p-0 mb-3">
                <div class="flex disabled-bg">
                    <div class="form-field field col">
                        <label class="detail-heading" translate>lbl_name
                        </label>
                        <div class="form-control font-bold">
                            {{product.name}}
                        </div>
                    </div>
                    @if( configService.isSiteUser() && isPatientManagmentOn) {
                    <div class="form-field field col-3">
                        <label class="flex" translate>order.lbl_patients
                        </label>
                        <div class="form-control font-bold">
                            <a class="view-patient-link" (click)="openPatientDialog(product.patientCodes)">
                                <span translate>order.lbl_view_patient</span>
                            </a>
                        </div>
                    </div>
                    }
                    <div class="form-field field equal-width-field">
                        <label class="detail-heading" translate>order.lbl_qty
                        </label>
                        <div class="form-control font-bold">
                            {{product.qty}}
                        </div>
                    </div>
                    @if ((configService.isTenantAdmin() || configService.isReviewer() )) {
                    <div class="form-field field equal-width-field">
                        <label class="detail-heading" translate>order.lbl_unit_cost
                        </label>
                        <div class="form-control font-bold">
                            ${{product.unitCost | number:'1.2-2'}}
                        </div>
                    </div>
                    <div class="form-field field equal-width-field">
                        <label class="detail-heading" translate>order.lbl_price
                        </label>
                        <div class="form-control font-bold">
                            ${{product.price | number:'1.2-2'}}
                        </div>
                    </div>
                    <div class="form-field field equal-width-field">
                        <label class="detail-heading" translate>order.lbl_total
                        </label>
                        <div class="form-control font-bold">
                            ${{product.total | number:'1.2-2'}}
                        </div>
                    </div>
                    }
                </div>
                @if (shouldShowProductDetails) {


                @for (item of product.item; track $index) {
                <div class="flex p-2">
                    <div class="form-field col-4">
                        <label class="detail-heading" translate>order.lbl_qty_received</label>
                        <div class="form-control text-base font-semibold qty-table">{{ getOriginalQuantity(item)
                            }}</div>
                    </div>
                    <div class="form-field col-4">
                        <label class="detail-heading" translate>order.lbl_batch</label>
                        <div class="form-control text-base font-semibold qty-table">{{ getBatchNumber(item) }}
                        </div>
                    </div>
                    <div class="form-field col-4">
                        <label class="detail-heading" translate>lbl_expiry_date</label>
                        <div class="form-control text-base font-semibold qty-table">{{ getFormattedDate(item) }}
                        </div>
                    </div>


                </div>
                }
                }
                @if (configService.isSiteUser() && (orderStatus === 'ORDER_DISPATCHED' || orderStatus ===
                'AWAITING_ORDER_RECEIVE_CONFIRMATION' || orderStatus ===
                'ORDER_PARTIALLY_CONFIRMED')) {
                <div class="m-2 mt-3">
                    <span class="sub-header col-12" translate>order.lbl_confirm_product_s</span>
                    @for (batch of product.confirmBatches; track $index) {
                    <div class="flex justify-content-start">
                        <div class="form-field field col-3">
                            <label class="flex" translate>order.lbl_qty_received<span
                                    class="required">*</span></label>
                            <div class="form-control">
                                <p-inputNumber [(ngModel)]="batch.confirmQty" mode="decimal" [useGrouping]="false"
                                    class="w-full"
                                    [placeholder]="'order.lbl_qty_received' | translate"
                                    [required]="(!batch.confirmQty && !batch.showReturn) ? true : false"
                                    #confirmQty="ngModel" (onInput)="onConfirmQtyChange(batch)"
                                    (onBlur)="onConfirmQtyChange(batch)"
                                    [ngClass]="{'disabled-input': !batch.showReturn}" [max]="product.qty" [min]="0"
                                    [maxFractionDigits]="0" />
                            </div>
                            @if (!batch.showReturn) {
                            <div class="text-xs text-gray-500 mt-1 flex">
                                <i class="pi pi-info-circle mr-1"></i>
                                <span translate>order.lbl_click_return_to_edit</span>
                            </div>
                            }
                            @if (confirmQty.invalid && confirmQty.touched) {
                            <div class="form-errors mt-1 required-field">
                                <div translate>
                                    order.error_quantity_invalid
                                </div>
                            </div>
                            }
                        </div>
                        <div class="form-field field col-3">
                            <label class="flex" translate>order.lbl_batch<span class="required">*</span></label>
                            <div class="form-control">
                                <input class="p-component p-element w-full" type="text" pInputText
                                    [(ngModel)]="batch.confirmBatch"
                                    [placeholder]=" 'order.lbl_batch' | translate"
                                    [required]="(batch.confirmQty > 0) ? true : false" #confirmBatch="ngModel"
                                    (input)="clearConfirmBatchError(batch)"
                                    (blur)="clearConfirmBatchError(batch)"
                                    maxlength="20" />
                            </div>
                            @if (batch.confirmBatchError) {
                            <div class="form-errors mt-1 required-field">
                                @if (batch.confirmBatchMaxLengthError) {
                                <div translate>
                                    order.error_batch_max_length
                                </div>
                                } @else {
                                <div translate>
                                    order.error_batch
                                </div>
                                }
                            </div>
                            }
                        </div>
                        <div class="form-field field col-3">
                            <label class="flex" translate>order.lbl_expiry<span class="required">*</span></label>
                            <div class="form-control">
                                <p-calendar
                                    [showIcon]="true"
                                    [style]="{width: '100%'}"
                                    appendTo="body"
                                    [dateFormat]="'dd/mm/yy'"
                                    [placeholder]="'lbl_select_date' | translate"
                                    [(ngModel)]="batch.confirmExpDate"
                                    dateFormat="dd M yy"
                                    [minDate]="today"
                                    [required]="(batch.confirmQty > 0) ? true : false"
                                    [showOnFocus]="true"
                                    #confirmExpDate="ngModel"
                                    (onSelect)="clearConfirmExpDateError(batch)"
                                    (onBlur)="clearConfirmExpDateError(batch)" />
                            </div>
                            @if (batch.confirmExpDateError) {
                            <div class="form-errors mt-1 required-field">
                                <div translate>
                                    order.error_expiry_date
                                </div>
                            </div>
                            }
                        </div>

                        <div class="form-field field col-1 mt-2 align-content-around">
                            <div class="form-control">
                                @if (($index) >= 1) {
                                <i class="{{miIcons.OFF_OUTLINE_CLOSE}} inline-block wh-16 mr-2 relative cursor-pointer"
                                    (click)="removeBatch(product, $index)"></i>
                                }
                            </div>
                        </div>
                    </div>
                    }
                    <div class="flex justify-content-start mt-2">
                        <button type="button"
                            class="add-new-batch-btn"
                            (click)="onAddNewBatch(product)"
                            [disabled]="product.confirmBatches.length >= product.qty">
                            <span class="pi pi-plus-circle mr-2" style="font-size: 1.3rem;"></span>
                            <span translate>order.lbl_add_new_batch</span>
                        </button>
                    </div>
                    @if (product.confirmBatches.length >= product.qty) {
                    <div
                        class="text-xs text-red-500 mt-1 flex justify-content-start">
                        <span translate>order.lbl_max_batches_reached</span>
                    </div>
                    }
                    <hr class="hr-line mx-2">
                    @if (product.returnBatches.length >= 0) {
                    <span class="sub-header col-12" translate>order.lbl_return_product_s</span>
                    @for (batch of product.returnBatches; track $index) {
                    <div class="flex justify-content-between">
                        <div class="form-field field col-3">
                            <label class="flex" translate>order.lbl_qty_returned
                            </label>
                            <div class="form-control">
                                <p-inputNumber [(ngModel)]="batch.returnQty" mode="decimal" [useGrouping]="false"
                                    class="w-full" #returnQty="ngModel"
                                    [placeholder]=" 'order.lbl_qty_received' | translate"
                                    (onInput)="onReturnQtyChange(product)" (onBlur)="onReturnQtyChange(product)"
                                    [max]="product.qty" [min]="0" [maxFractionDigits]="0" />
                            </div>
                            @if (batch.returnQtyError) {
                            <div class="form-errors mt-1 required-field">
                                <div translate>
                                    order.error_qty_returned_greater_than_zero
                                </div>
                            </div>
                            } @else if (returnQty.invalid && returnQty.touched) {
                            <div class="form-errors mt-1 required-field">
                                <div translate>
                                    order.error_quantity_invalid
                                </div>
                            </div>
                            }
                        </div>
                        <div class="form-field field col-3">
                            <label class="flex" translate>order.lbl_batch<span class="required">*</span>
                            </label>
                            <div class="form-control">
                                <input class="p-component p-element w-full" type="text" pInputText
                                    [(ngModel)]="batch.returnBatch" required #returnBatch="ngModel"
                                    [placeholder]=" 'order.lbl_batch' | translate"
                                    (input)="clearReturnBatchError(batch)"
                                    (blur)="clearReturnBatchError(batch)"
                                    maxlength="20" />
                            </div>
                            @if (batch.returnBatchError) {
                            <div class="form-errors mt-1 required-field">
                                @if (batch.returnBatchMaxLengthError) {
                                <div translate>
                                    order.error_batch_max_length
                                </div>
                                } @else {
                                <div translate>
                                    order.error_batch
                                </div>
                                }
                            </div>
                            }
                        </div>
                        <div class="form-field field col-2">
                            <label class="flex" translate>order.lbl_expiry<span class="required">*</span>
                            </label>
                            <div class="form-control">
                                <p-calendar
                                    required #returnExpDate="ngModel"
                                    [showIcon]="true"
                                    [style]="{width: '100%'}"
                                    [dateFormat]="'dd/mm/yy'"
                                    appendTo="body"
                                    dateFormat="dd M yy"
                                    [(ngModel)]="batch.returnExpDate"
                                    [placeholder]="'lbl_select_date' | translate"
                                    [showOnFocus]="true"
                                    (onSelect)="clearReturnExpDateError(batch)"
                                    (onBlur)="clearReturnExpDateError(batch)" />
                            </div>
                            @if (batch.returnExpDateError) {
                            <div class="form-errors mt-1 required-field">
                                <div translate>
                                    order.error_expiry_date
                                </div>
                            </div>
                            }
                        </div>

                        <div class="form-field field col-3">
                            <label class="flex" translate>order.lbl_rejection_reason_type<span
                                    class="required">*</span>
                            </label>
                            <div class="form-control">
                                <p-dropdown [options]="rejectionReasonOptions" [(ngModel)]="batch.returnReasonType"
                                    [placeholder]="'lbl_reason_for_rejection' | translate"
                                    optionValue="labelKey"
                                    optionLabel="labelValue"
                                    (onChange)="clearReturnReasonTypeError(batch)"
                                    (onBlur)="clearReturnReasonTypeError(batch)" />
                            </div>
                            @if (batch.returnReasonTypeError) {
                            <div class="form-errors mt-1 required-field">
                                <div translate>
                                    order.error_rejection_reason_type
                                </div>
                            </div>
                            }
                        </div>
                        <div class="form-field field col-1 mt-4 align-content-around">
                            <i class="{{miIcons.OFF_OUTLINE_CLOSE}} inline-block wh-16 mr-2 relative cursor-pointer"
                                (click)="onRemoveReturnBatch(product, $index)"></i>
                        </div>
                    </div>
                    @if (batch.returnReasonType === 'OTHER') {
                    <div class="form-field field">
                        <label class="flex" translate>lbl_reason_for_rejection
                            <span class="required">*</span>
                        </label>
                        <div class="form-control">
                            <textarea
                                pInputTextarea
                                [(ngModel)]="batch.returnReason"
                                class="p-component p-element w-full"
                                rows="5"
                                cols="30"
                                appAutoFocus
                                [placeholder]=" 'lbl_reason_for_rejection' | translate"
                                required
                                maxlength="500"
                                (input)="clearReturnReasonError(batch)"
                                (blur)="clearReturnReasonError(batch)">
                                        </textarea>
                        </div>
                        <div class="form-hint mt-1 flex w-full justify-between">
                            <div class="text-muted">({{ 'order.lbl_reason_for_rejection_max_hint' | translate }})</div>
                        </div>
                        @if (batch.returnReasonError) {
                        <div class="form-errors mt-1 required-field">
                            @if (batch.returnReasonMaxLengthError) {
                            <div translate>
                                order.error_return_reason_max_length
                            </div>
                            } @else {
                            <div translate>
                                lbl_reason_for_rejection_req
                            </div>
                            }
                        </div>
                        }
                    </div>
                    }
                    }


                    @if (product.returnBatches.length === 0) {
                    <div class="flex align-items-center mb-2 col-12">
                        <button pButton icon="{{miIcons.REFRESH}} inline-block wh-20 mr-2 relative bg-red-ff"
                            class="col-3 flex align-items-center justify-content-center bg-white return-btn"
                            [label]="'order.lbl_return' | translate" (click)="onAddNewReturnBatch(product)">
                            <!-- <i class=""></i> -->
                        </button>
                        <i class="pi pi-info-circle mx-2"></i>
                        <span class="info-text" translate>order.lbl_initiate_the_return</span>
                    </div>
                    } @else {

                    <div class="flex justify-content-start mt-2">
                        <button type="button"
                            class="add-new-batch-btn"
                            (click)="onAddNewReturnBatch(product)"
                            [disabled]="product.returnBatches.length >= product.qty">
                            <span class="pi pi-plus-circle mr-2" style="font-size: 1.3rem;"></span>
                            <span translate>order.lbl_add_new_batch</span>
                        </button>
                    </div>
                    }

                    @if (product.returnBatches.length >= product.qty) {
                    <div class="text-xs text-red-500 mt-1 flex justify-content-start">
                        <span translate>order.lbl_max_batches_reached</span>
                    </div>
                    }

                    } @else {

                    }
                </div>
                }
            </div>
            }


            <app-quantity-product-table [orderSummary]="orderSummary"
                [products]="products"></app-quantity-product-table>


        </div>
        @if (configService.isSiteUser() && (orderStatus === 'ORDER_DISPATCHED' || orderStatus ===
        'AWAITING_ORDER_RECEIVE_CONFIRMATION' || orderStatus ===
        'ORDER_PARTIALLY_CONFIRMED') && isStatusUpdate) {
        <div class="flex justify-content-start flex-wrap btn-with-links mb-3">
            @if (!isProductReturned) {
            <p-button class="flex align-items-center justify-content-center button-hide"
                icon="{{miIcons.CIRCLE_CHECK_OUTLINE}} block wh-24 bg-white"
                [label]="'order.lbl_confirm_order_received' | translate" (click)="showConfirmOrder()"></p-button>
            } @else {
            <p-button class="flex align-items-center justify-content-center button-hide"
                icon="{{miIcons.DASH_CHECKED}} block wh-24 bg-white"
                [label]="'order.lbl_confirm_order_received_initiate_return' | translate"
                (click)="showConfirmOrderAndReturn()"></p-button>
            }
        </div>
        }

        <p-dialog [(visible)]="showConfirmOrderDialog" [modal]="true" [closable]="true" [responsive]="true"
            [style]="{width: '550px'}" (onHide)="onConfirmOrderDialogHide()">
            <p-header translate>order.label_confirm_order</p-header>
            <b class="flex my-3" translate>order.msg_confirm_order_received</b>

            <p-footer>
                <button type="button" pButton [label]="'lbl_cancel' | translate" class="noChange  cancel-order-btn"
                    (click)="showConfirmOrderDialog = false"></button>
                <button type="button" pButton
                    [label]="isConfirmOrderInProgress ? ('lbl_processing' | translate) : ('order.label_confirm_order' | translate)"
                    class="discard"
                    [disabled]="isConfirmOrderInProgress" (click)="confirmOrder()"></button>
            </p-footer>
        </p-dialog>
        @if (showReturnOrderDialog) {
        <p-dialog class="form-dialog" [(visible)]="showReturnOrderDialog" [modal]="true" [closable]="true"
            [responsive]="true" [style]="{width: '650px'}" (onHide)="onReturnOrderDialogHide()">
            <p-header translate>order.label_confirm_order</p-header>
            <b class="flex my-3" translate>order.msg_confirm_order_received_return</b>
            <span translate>order.lbl_out_of<b>{{getTotalQuantity()}}, {{getTotalQuantity() -
                    getTotalReturningQuantity()}}</b><span
                    translate>order.lbl_have_confirmed_and</span><b>{{getTotalReturningQuantity()}}</b><span
                    translate>order.lbl_processed_for_return</span>
            </span>
            @for (tab of confirmAttributeData?.tabs; track tab; let i = $index) {
            <div>
                <app-mi-form [attributeLabels]="dialogAttrLabels" [attributeValues]="attributeValues"
                    [moduleName]="'order'"
                    [groups]="tab.groups" (saveData)="confirmOrderReturn($event)" [showImg]="false"
                    [isMultipleFilesUpload]="true"
                    [submitBtnText]="isConfirmOrderInProgress ? ('lbl_processing' | translate) : ('order.lbl_confirm_order_received_initiate_return' | translate)"
                    [activeIndex]="0" [showCancelButton]="true"
                    [saveBtnId]="prefixToAttachForButtonIdToUniquelyIdentifyButton + tab.tabCode"
                    [submitButtonDisabled]="isConfirmOrderInProgress"
                    (onCancel)="showReturnOrderDialog = false"></app-mi-form>
            </div>

            }
        </p-dialog>
        }
        }
        <app-new-back-order-received [orderStatus]="orderStatus" [products]="products"
            [orderSummary]="orderSummary" [isPatientManagmentOn]="isPatientManagmentOn"></app-new-back-order-received>

    </div>

    <div class="col-6 md:col-12 lg:col-4 update-container" style="height: 100vh; position: relative;">
        <app-status-updates
            [events]="events"
            [orderStatus]="orderStatus"
            [attributeValues]="attributeValues"
            [metaDataService]="metaDataService"
            [configService]="configService"
            [isStatusUpdate]="isStatusUpdate"
            [showPartialOrderButton]="showPartialOrderButton"
            (openFullOrderDialog)="openFullOrderDialog()"
            [orderStatusConst]="ORDER_STATUS"
            [eventStatusConst]="EVENT_STATUS"
            (showPartialOrderDialogBoxChange)="openPartialOrderDialog()"
            (showRejectOrderDialogBoxChange)="showRejectOrderDialogBox = $event"></app-status-updates>
    </div>

</div>
}
<app-patient-info [visible]="showPatientDialog" [patientCodes]="selectedPatientCodes"
    (onClose)="closePatientDialog()"></app-patient-info>

@if (showFullOrderDialogBox) {
<p-dialog [(visible)]="showFullOrderDialogBox" [modal]="true" [closable]="true" [responsive]="true"
    [style]="{width: '550px'}" (onHide)="onCancelFullOrder()">
    <p-header translate>order.lbl_full_order_confirmation</p-header>
    <form [formGroup]="fullOrderForm" class="mt-4 mb-4">
        <input type="text" id="hiddenInputFull" #hiddenInputFull
            style="position: absolute; left: -9999px; opacity: 0;" />
        <div class="form-field field">
            <label class="flex" translate>lbl_date_of_dispatch
                <span class="required">*</span>
            </label>
            <div class="form-control">
                <p-calendar
                    formControlName="dispatchDate"
                    [showIcon]="true"
                    inputId="buttondisplay"
                    [dateFormat]="'dd/mm/yy'"
                    [style]="{width: '100%'}"
                    appendTo="body"
                    [minDate]="minDate"
                    [placeholder]="'lbl_select_date' | translate"
                    [autoFocus]="false"
                    [showOnFocus]="true" />
            </div>
            @if (fullOrderForm.controls.dispatchDate.errors && (fullOrderForm.controls.dispatchDate.dirty ||
            fullOrderForm.controls.dispatchDate.touched)) {
            <div class="form-errors mt-1 required-field">
                @if(fullOrderForm.controls.dispatchDate.errors?.required){
                <div translate>
                    lbl_date_of_dispatch_req
                </div>
                }
            </div>
            }
        </div>
        <div class="form-field field">
            <label class="flex" translate>lbl_expected_delivery_date
                <span class="required">*</span>
            </label>
            <div class="form-control">
                <p-calendar
                    formControlName="expectedDispatchDate"
                    [showIcon]="true"
                    inputId="buttondisplay"
                    [dateFormat]="'dd/mm/yy'"
                    [style]="{width: '100%'}"
                    appendTo="body"
                    [minDate]="expectedDispatchMinDate"
                    [placeholder]="'lbl_select_date' | translate"
                    [autoFocus]="false"
                    [showOnFocus]="true" />
            </div>
            @if (fullOrderForm.controls.expectedDispatchDate.errors &&
            (fullOrderForm.controls.expectedDispatchDate.dirty ||
            fullOrderForm.controls.expectedDispatchDate.touched))
            {
            <div class="form-errors mt-1 required-field">
                @if(fullOrderForm.controls.expectedDispatchDate.errors?.required){
                <div translate>
                    lbl_expected_date_of_dispatch_req
                </div>
                }
            </div>
            }
        </div>

        @for (product of products; track $index) {
        <div class="border-box p-0">
            <div class="flex disabled-bg">
                <div class="form-field field col-12">
                    <label class="flex" translate>lbl_name
                    </label>
                    <div class="form-control font-bold">
                        {{product.name}}
                    </div>
                </div>

            </div>
            <div class="flex mb-3 mt-2">
                <div class="form-field field col-6">
                    <label class="flex" translate>order.lbl_unit_cost
                        <span class="required">*</span>
                    </label>
                    <div class="form-control">
                        <p-inputNumber
                            [(ngModel)]="product.tempUnitCost"
                            [min]="1"
                            [mode]="'decimal'"
                            [useGrouping]="false"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            required
                            #unitCost="ngModel"
                            [ngModelOptions]="{ standalone: true }"
                            class="w-full"
                            [placeholder]="'order.lbl_unit_cost' | translate">
                        </p-inputNumber>
                    </div>
                    @if (unitCost.invalid && unitCost.touched) {
                    <div class="form-errors mt-1 required-field">
                        <div translate>lbl_unit_cost_required</div>
                    </div>
                    }
                </div>

            </div>

        </div>
        }
    </form>

    <p-footer>
        <button type="button" pButton [label]="'lbl_cancel' | translate" class="noChange  cancel-order-btn"
            (click)="onCancelFullOrder()"></button>
        <button type="button" pButton [label]="'lbl_confirm' | translate" class="discard"
            (click)="onConfirmFullOrder()"></button>
    </p-footer>
</p-dialog>
}

@if (showPartialOrderDialogBox) {
<p-dialog [(visible)]="showPartialOrderDialogBox" [modal]="true" [closable]="true" [responsive]="true"
    [style]="{width: '600px'}" (onHide)="onCancelPartialOrder()">
    <p-header translate>order.lbl_partial_order_confirmation</p-header>
    <form [formGroup]="partialOrderForm" class="mt-4 mb-4">
        <input type="text" id="hiddenInputPartial" #hiddenInputPartial
            style="position: absolute; left: -9999px; opacity: 0;" />
        <div class="flex mb-2">
            <div class="form-field field col-6 pl-0">
                <label class="flex" translate>order.lbl_dispatch_date_of_product_in_stock
                    <span class="required">*</span>
                </label>
                <div class="form-control">
                    <p-calendar
                        formControlName="dispatchDateInStockProduct"
                        [showIcon]="true"
                        [dateFormat]="'dd/mm/yy'"
                        inputId="buttondisplay"
                        [minDate]="minDate"
                        [style]="{width: '100%'}"
                        appendTo="body"
                        [placeholder]=" 'lbl_select_date' | translate"
                        [autoFocus]="false"
                        [showOnFocus]="true" />
                </div>
                @if (partialOrderForm.controls.dispatchDateInStockProduct.errors &&
                (partialOrderForm.controls.dispatchDateInStockProduct.dirty ||
                partialOrderForm.controls.dispatchDateInStockProduct.touched)) {
                <div class="form-errors mt-1 required-field">
                    @if(partialOrderForm.controls.dispatchDateInStockProduct.errors?.required){
                    <div translate>
                        lbl_date_of_dispatch_req
                    </div>
                    }
                </div>
                }
            </div>
            <div class="form-field field col-6 pr-0">
                <label class="flex" translate>order.lbl_dispatch_date_of_remaining_products
                    @if (!isOrderSplit) {
                    <span class="required">*</span>
                    }
                </label>
                <div class="form-control">
                    <p-calendar
                        formControlName="dispatchDateRemainingProduct"
                        [showIcon]="true"
                        [dateFormat]="'dd/mm/yy'"
                        inputId="buttondisplay"
                        [minDate]="minDate"
                        [style]="{width: '100%'}"
                        appendTo="body"
                        [placeholder]=" 'lbl_select_date' | translate"
                        [autoFocus]="false"
                        [showOnFocus]="true"
                        [disabled]="isOrderSplit" />
                </div>
                @if (!isOrderSplit && partialOrderForm.controls.dispatchDateRemainingProduct.errors &&
                (partialOrderForm.controls.dispatchDateRemainingProduct.dirty ||
                partialOrderForm.controls.dispatchDateRemainingProduct.touched)) {
                <div class="form-errors mt-1 required-field">
                    @if(partialOrderForm.controls.dispatchDateRemainingProduct.errors?.required){
                    <div translate>
                        lbl_date_of_dispatch_req
                    </div>
                    }
                </div>
                }
                @if (!isOrderSplit && partialOrderForm.errors?.dispatchDateMismatch && partialOrderForm.touched) {
                <div class="form-errors mt-1 required-field">
                    <div translate>lbl_remaining_date_should_be_after_in_stock_date</div>
                </div>
                }
            </div>
        </div>
        <div class="form-field field">
            <label class="flex" translate>lbl_expected_delivery_date
                <span class="required">*</span>
            </label>
            <div class="form-control">
                <p-calendar
                    formControlName="expectedDispatchDate"
                    [showIcon]="true"
                    inputId="buttondisplay"
                    [dateFormat]="'dd/mm/yy'"
                    [style]="{width: '100%'}"
                    appendTo="body"
                    [minDate]="partialExpectedDispatchMinDate"
                    [placeholder]="'lbl_select_date' | translate"
                    [autoFocus]="false"
                    [showOnFocus]="true" />
            </div>
            @if (partialOrderForm.controls.expectedDispatchDate.errors &&
            (partialOrderForm.controls.expectedDispatchDate.dirty ||
            partialOrderForm.controls.expectedDispatchDate.touched)) {
            <div class="form-errors mt-1 required-field">
                @if(fullOrderForm.controls.expectedDispatchDate.errors?.required){
                <div translate>
                    lbl_expected_date_of_dispatch_req
                </div>
                }
            </div>
            }
        </div>
        @if (products && products.length > 1) {
        <div class="flex justify-content-start mb-3">
            @if (!isOrderSplit) {
            <p-button class="secondary-btn" [label]="'order.lbl_split_order' | translate"
                (click)="onSplitOrder()"></p-button>
            } @else {
            <p-button class="secondary-btn" [label]="'order.lbl_remove_split_order' | translate"
                (click)="onRemoveSplitOrder()"></p-button>
            }
        </div>
        }
        @for (product of products; track $index) {
        <div class="border-box p-0">
            <div class="flex disabled-bg">
                <div class="form-field field col-9">
                    <label class="flex" translate>lbl_name
                    </label>
                    <div class="form-control font-bold">
                        {{product.name}}
                    </div>
                </div>

                <div class="form-field field col-3">
                    <label class="flex" translate>order.lbl_required_qty
                    </label>
                    <div class="form-control font-bold">
                        {{product.qty}}
                    </div>
                </div>
            </div>

            <div class="flex mb-3 mt-2">
                <div class="form-field field" [ngClass]="isOrderSplit ? 'col-6' : 'col-4'">
                    <label class="flex" translate>order.lbl_product_in_stock
                        <span class="required">*</span>
                    </label>
                    <div class="form-control">
                        <p-inputNumber
                            [formControl]="partialOrderForm.get('availableProductQty')['controls'][$index].get('inStock')"
                            [min]="0"
                            [max]="999999"
                            [mode]="'decimal'"
                            [useGrouping]="false"
                            [maxFractionDigits]="0"
                            [showButtons]="false"
                            inputStyleClass="w-full"
                            [placeholder]="'order.lbl_product_in_stock' | translate"
                            (onInput)="onStockUpdate($index)"
                            style="width: 100%;"
                            #productInput
                            id="product-in-stock-{{$index}}">
                        </p-inputNumber>
                    </div>
                    @if (
                    partialOrderForm.get('availableProductQty')['controls'][$index].get('inStock').errors &&
                    (partialOrderForm.get('availableProductQty')['controls'][$index].get('inStock').touched ||
                    partialOrderForm.get('availableProductQty')['controls'][$index].get('inStock').dirty)
                    ) {
                    <div class="mt-1 required-field">
                        @if(partialOrderForm.get('availableProductQty')['controls'][$index].get('inStock').errors?.required)
                        {
                        <div translate>lbl_product_in_stock_required</div>
                        }
                        @if(partialOrderForm.get('availableProductQty')['controls'][$index].get('inStock').errors?.exceedQty)
                        {
                        <div translate>lbl_quantity_exceed_msg</div>
                        }
                        @if(partialOrderForm.get('availableProductQty')['controls'][$index].get('inStock').errors?.maxLimitExceeded)
                        {
                        <div translate>lbl_max_limit_exceeded</div>
                        }
                    </div>
                    }
                </div>
                <div class="form-field field" [ngClass]="isOrderSplit ? 'col-6' : 'col-4'">
                    <label class="flex" translate>order.lbl_remaining_products
                        <span class="required">*</span>
                    </label>
                    <div class="form-control">
                        <input [disabled]="true" [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="product.remaining"
                            class="p-component p-element w-full" type="text" pInputText appAutoFocus
                            [placeholder]=" 'order.lbl_remaining_products' | translate" required />
                    </div>
                </div>
                @if (!isOrderSplit) {
                <div class="form-field field col-4">
                    <label class="flex" translate>order.lbl_unit_cost
                        <span class="required">*</span>
                    </label>
                    <div class="form-control">
                        <p-inputNumber
                            [(ngModel)]="product.tempUnitCost"
                            [min]="1"
                            [mode]="'decimal'"
                            [useGrouping]="false"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            required
                            #partialUnitCost="ngModel"
                            [ngModelOptions]="{ standalone: true }"
                            class="w-full"
                            [placeholder]="'order.lbl_unit_cost' | translate">
                        </p-inputNumber>
                    </div>
                    @if (partialUnitCost.invalid && partialUnitCost.touched) {
                    <div class="form-errors mt-1 required-field">
                        <div translate>lbl_unit_cost_required</div>
                    </div>
                    }
                </div>
                }
            </div>
            @if (isOrderSplit) {
            <div class="flex mb-3 mt-2">
                <div class="form-field field col-6">
                    <label class="flex" translate>order.lbl_unit_cost
                        <span class="required">*</span>
                    </label>
                    <div class="form-control">
                        <p-inputNumber
                            [(ngModel)]="product.tempUnitCost"
                            [min]="1"
                            [mode]="'decimal'"
                            [useGrouping]="false"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            required
                            #partialUnitCost="ngModel"
                            [ngModelOptions]="{ standalone: true }"
                            class="w-full"
                            [placeholder]="'order.lbl_unit_cost' | translate">
                        </p-inputNumber>
                    </div>
                    @if (partialUnitCost.invalid && partialUnitCost.touched) {
                    <div class="form-errors mt-1 required-field">
                        <div translate>lbl_unit_cost_required</div>
                    </div>
                    }
                </div>
                <div class="form-field field col-6">
                    <label class="flex" translate>order.lbl_dispatch_date
                        @if (products[$index].remaining > 0) {
                        <span class="required">*</span>
                        }
                    </label>
                    <div class="form-control">
                        <p-calendar
                            [formControl]="partialOrderForm.get('availableProductQty')['controls'][$index].get('dispatchDate')"
                            [showIcon]="true"
                            [dateFormat]="'dd/mm/yy'"
                            [style]="{width: '100%'}"
                            appendTo="body"
                            [minDate]="minDate"
                            [placeholder]="'lbl_select_date' | translate"
                            [autoFocus]="false"
                            [showOnFocus]="true"
                            [disabled]="products[$index].remaining === 0" />
                    </div>
                    @if (
                    partialOrderForm.get('availableProductQty')['controls'][$index].get('dispatchDate')?.errors &&
                    (partialOrderForm.get('availableProductQty')['controls'][$index].get('dispatchDate')?.touched ||
                    partialOrderForm.get('availableProductQty')['controls'][$index].get('dispatchDate')?.dirty)
                    ) {
                    <div class="mt-1 required-field">
                        @if(partialOrderForm.get('availableProductQty')['controls'][$index].get('dispatchDate')?.errors?.required)
                        {
                        <div translate>lbl_dispatch_date_required</div>
                        }
                    </div>
                    }
                </div>
            </div>
            }
        </div>
        }
    </form>

    <p-footer>
        <button type="button" pButton [label]="'lbl_cancel' | translate" class="noChange  cancel-order-btn"
            (click)="onCancelPartialOrder()"></button>
        <button type="button" pButton [label]="'lbl_confirm' | translate" class="discard"
            (click)="onConfirmPartialOrder()"></button>
    </p-footer>
</p-dialog>
}

@if(showRejectOrderDialogBox) {
<p-dialog [(visible)]="showRejectOrderDialogBox" [modal]="true" [closable]="true" [responsive]="true"
    [style]="{width: '550px'}" (onHide)="onCancelRejectOrder()">
    <p-header translate>lbl_reject_order</p-header>

    <form [formGroup]="rejectOrderForm" class="mt-4 mb-4">
        <div class="form-field field">
            <label class="flex" translate>lbl_reason_for_cancellation
                <span class="required">*</span>
            </label>
            <div class="form-control">
                <textarea
                    pInputTextarea
                    formControlName="reason"
                    class="p-component p-element w-full"
                    rows="5"
                    cols="30"
                    appAutoFocus
                    [placeholder]=" 'lbl_placeholder_reason_for_rejection' | translate"
                    required
                    maxlength="500">
                    </textarea>
            </div>

            <div class="form-hint mt-1 flex w-full justify-between">
                <div class="text-muted">({{ 'order.lbl_reason_for_rejection_max_hint' | translate }})</div>
            </div>
            @if (rejectOrderForm.controls.reason.errors && (rejectOrderForm.controls.reason.dirty ||
            rejectOrderForm.controls.reason.touched)) {
            <div class="form-errors mt-1 required-field">
                @if(rejectOrderForm.controls.reason.errors?.required){
                <div translate>
                    lbl_reason_for_cancellation_req
                </div>
                }
                @if(rejectOrderForm.controls.reason.errors?.maxlength){
                <div translate>
                    order.lbl_reason_for_rejection_max
                </div>
                }
            </div>
            }
        </div>
    </form>

    <p-footer>
        <button type="button" pButton [label]="'lbl_cancel' | translate" class="noChange  cancel-order-btn"
            (click)="onCancelRejectOrder()"></button>
        <button type="button" pButton [label]="'lbl_reject_order' | translate" class="discard"
            (click)="onConfirmRejectOrder()"></button>
    </p-footer>
</p-dialog>
}